const set = require('regenerate')(0x640);
set.addRange(0x10F30, 0x10F59);
module.exports = set;
